/**
 * @generated SignedSource<<b1010a4d9b4fdcfdb4aff41a0939be79>>
 * @relayHash ff313d207a9f61eebd49c3747c4183c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09ddc01df37054087d26af4afb12c541e8538e74d98f2b799ba035c8e16226c1

import type { ConcreteRequest, Query } from 'relay-runtime';
export type blockServiceSnippetSharingQuery$variables = Record<PropertyKey, never>;
export type blockServiceSnippetSharingQuery$data = {
  readonly confluence: {
    readonly siteConfiguration: {
      readonly isSnippetSharingForSiteEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type blockServiceSnippetSharingQuery = {
  response: blockServiceSnippetSharingQuery$data;
  variables: blockServiceSnippetSharingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSiteConfiguration",
        "kind": "LinkedField",
        "name": "siteConfiguration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isSnippetSharingForSiteEnabled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "blockServiceSnippetSharingQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "blockServiceSnippetSharingQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ff313d207a9f61eebd49c3747c4183c9",
    "id": "09ddc01df37054087d26af4afb12c541e8538e74d98f2b799ba035c8e16226c1",
    "metadata": {},
    "name": "blockServiceSnippetSharingQuery",
    "operationKind": "query",
    "text": "query blockServiceSnippetSharingQuery{confluence{siteConfiguration{isSnippetSharingForSiteEnabled}}}"
  }
};
})();

(node as any).hash = "805dcad659b8bcb81d65d75de955c74f";

export default node;
